import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Explore from "@/pages/Explore";
import Dashboard from "@/pages/Dashboard";
import PlaceDetail from "@/pages/PlaceDetail";
import TripBuilder from "@/pages/TripBuilder";
import TripView from "@/pages/TripView";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/explore" element={<Explore />} />
                        <Route path="/place" element={<PlaceDetail />} />
                        <Route path="/trip/:slug" element={<TripView />} />
                        <Route
                            path="/trips/new"
                            element={
                                <ProtectedRoute>
                                    <TripBuilder />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/dashboard"
                            element={
                                <ProtectedRoute>
                                    <Dashboard />
                                </ProtectedRoute>
                            }
                        />
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
